module.exports = __webpack_public_path__ + "5b5eed7b17375aef8a11876a779b2835.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/history/5.jpg
// module id = 305
// module chunks = 0